import { useEffect, useState } from 'react';
import { api, getToken, me } from './api';

export const headshotKey = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

let focusCache = null;
let focusPromise = null;
let staffPromise = null;
const listeners = new Set();

const loadFocus = () => {
  if (!focusPromise) focusPromise = api.get('/headshot-focus').then((r) => { focusCache = r.data; return focusCache; }).catch(() => (focusCache = {}));
  return focusPromise;
};

const loadStaff = () => {
  if (!getToken()) return Promise.resolve(false);
  if (!staffPromise) staffPromise = me().then(() => true).catch(() => false);
  return staffPromise;
};

export const saveHeadshotFocus = async (key, x, y) => {
  const { data } = await api.put(`/headshot-focus/${key}`, { x, y });
  focusCache = { ...(focusCache || {}), [key]: { x: data.x, y: data.y } };
  listeners.forEach((fn) => fn(focusCache));
  return data;
};

export const useHeadshotFocus = () => {
  const [focus, setFocus] = useState(focusCache || {});
  const [isStaff, setIsStaff] = useState(false);
  useEffect(() => {
    let alive = true;
    loadFocus().then((f) => alive && setFocus({ ...f }));
    loadStaff().then((s) => alive && setIsStaff(s));
    const fn = (f) => alive && setFocus({ ...f });
    listeners.add(fn);
    return () => { alive = false; listeners.delete(fn); };
  }, []);
  return { focus, isStaff };
};
